/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {BadgeIcon} from './badge-icon';

export class LogbookElement {
  get content(): string {
    return this._content;
  }

  set content(value: string) {
    this._content = value;
    if (value) {
      this.htmlContent = value;
    } else {
      this.htmlContent = null;
    }
  }
  public indice?: string;
  public date: Date;
  public icon: string|BadgeIcon;
  public author?: string;
  private _content: string;
  public change: {field: string, before: string, after: string}[];
  htmlContent: string;


  constructor(
    indice: string,
    date: Date,
    icon: string|true,
    author: string,
    content: string,
    change: { field: string; before: string; after: string }[]
  ) {
    this.indice = indice;
    this.date = date;
    this.author = author;
    this.icon = this.createIcon(icon);
    this.content = content;
    this.change = change;
  }

  public createIcon(icon: string|true) {
    if (icon === true || !icon) {
      return new BadgeIcon(this.author);
    } else {
      return icon;
    }
  }
}
